export const AUTHORIZATION_KEY = 'authorization';
export const TENANT_NAME_KEY = 'tenant';
export const TENANT_TYPE_KEY = 'tenantType';



// WEBPACK FOOTER //
// ./src/app/consts/auth.ts